import { render, staticRenderFns } from "./JourneyFormStandardGoodsTableRow.vue?vue&type=template&id=f77c9388&scoped=true&"
import script from "./JourneyFormStandardGoodsTableRow.vue?vue&type=script&lang=js&"
export * from "./JourneyFormStandardGoodsTableRow.vue?vue&type=script&lang=js&"
import style0 from "./JourneyFormStandardGoodsTableRow.vue?vue&type=style&index=0&id=f77c9388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77c9388",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
